import { useEffect, useRef } from "react";

/**
 * Adds the "in" class to elements with a "reveal" class when they enter the viewport.
 * Apply on a parent container; will observe all descendants matching `.reveal`.
 */
export const useReveal = (selector = ".reveal") => {
  const ref = useRef(null);

  useEffect(() => {
    const root = ref.current || document;
    const items = root.querySelectorAll(selector);
    if (!items.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );

    items.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [selector]);

  return ref;
};
